@if (schedule().length > 0){
  <section 
    class="details-page__schedule"
    [class.fromBottomSheet]="fromBottomSheet()"
  >
      <h3 
        class="ci-heading-h3-s-bold schedule__title"
      >
        {{ 'Horario' | translate }}
      </h3>
      <ul class="schedule__list">
          @for (item of schedule(); track item.day) {
              <li class="schedule__list__item">
                  <b>{{ item.day | translate }}: </b>
                  @for (time of item.time; track $index; let last = $last){
                      <span class="ci-paragraph-p3-semibold">
                        {{ time | translate }}
                      </span>
                      @if(!last){
                          <span> / </span>
                      }
                  }
              </li>
          }
      </ul>
  </section>
}